import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export interface TaxonomyDefinitionConfig {
  className: string
  namePlural: string
  nameSingular: string
  path: string
  propertiesToExcludeFromDisplay?: string[]
  slug: string
  title: string
}

export const createTaxonomyDefinition = ({
  className,
  namePlural,
  nameSingular,
  path,
  propertiesToExcludeFromDisplay = [
    'id',
    'createdAt',
    'updatedAt',
    'deletedAt',
    'propertiesInArray',
    'order'
  ],
  slug,
  title
}: TaxonomyDefinitionConfig): ResourceDefinition => ({
  title,
  nameSingular,
  namePlural,
  className,
  mainIdentifier: 'name',
  propertiesToExcludeFromDisplay,
  slug,
  path,
  icon: 'icon-tag',
  hasDetailPage: true,
  hasListPage: true,
  buttons: [],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
  dropdownLinks: []
})
